import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { reverse } from 'named-urls';
import ContentPreloader from '$components/student/ContentPreloader';
import routes from '@achievable-me/tundra-wizard/routes';
import styles from './styles.scss';
import { checkProductSlug } from '$lib/checkProductSlug';

class NextContentButton extends Component {
  render() {
    const { contentInstance, currentUser, flatContent, isAchievable, product } =
      this.props;

    const { slug: productSlug } = product;
    const { showPracticeExams } = checkProductSlug(productSlug);

    const contentIndex = _findIndex(flatContent, contentInstance);
    const futureContent = flatContent.slice(contentIndex + 1);
    const nextContent = _find(futureContent, (obj) => _isEmpty(obj.content));

    if (!nextContent) {
      // 20180106JP:FEATURE Should we have a "Content completed page?"

      if (isAchievable) {
        return (
          <Button data-aaa="nextContentButton">
            <Link to={reverse(routes.study.catalog, { productSlug: 'achievable' })}>
              All done! &rarr;<span className={styles.navigationDetail}> Catalog</span>
            </Link>
          </Button>
        );
      }

      if (showPracticeExams) {
        return (
          <Button data-aaa="nextContentButton">
            <Link to={reverse(routes.study.exams, { productSlug })}>
              Take practice exams &rarr;
            </Link>
          </Button>
        );
      }

      if (!currentUser) {
        return null;
      }

      return (
        <Button data-aaa="nextContentButton">
          <Link to={reverse(routes.study.dashboard, { productSlug })}>
            All done! &rarr;<span className={styles.navigationDetail}> Dashboard</span>
          </Link>
        </Button>
      );
    }

    return (
      <Button data-aaa="nextContentButton">
        <ContentPreloader uuid={nextContent.uuid} />
        <Link to={nextContent.path}>
          Next &rarr;<span className={styles.navigationDetail}> {nextContent.title}</span>
        </Link>
      </Button>
    );
  }
}

export default NextContentButton;
